import { Box, DashboardModule, Form } from '@domain-group/suit-theme'

import EntitySelectBox from '@components/EntitySelectBox'

import { UseFormPayload } from '@domain-group/react-hooks'

import MarketingAgencySelector from './MarketingAgencySelector'

interface AgencyDetailsProps {
  campaignForm: UseFormPayload,
  supportsCrossAgencyCollaboration: boolean,
}

const AgencyDetails = (props: AgencyDetailsProps) => {
  const { campaignForm, supportsCrossAgencyCollaboration } = props

  const { entityState: { agency_id }, handlers } = campaignForm

  return (
    <DashboardModule boxProps={{ marginBottom: 'large' }} title="Agency">
      <Box flexDirection="column" padding="large">
        <Form.Row
          columns={supportsCrossAgencyCollaboration ? ['repeat(1, 1fr)', 'repeat(2, 1fr)'] : ['repeat(1, 1fr)']}
        >
          <Form.Field label="Owner">
            <EntitySelectBox
              entityKey="agencies"
              // @ts-expect-error TS2322
              name="agency_id"
              value={agency_id}
              {...handlers}
            />
          </Form.Field>

          {supportsCrossAgencyCollaboration && (
            <MarketingAgencySelector campaignForm={campaignForm} />
          )}
        </Form.Row>
      </Box>
    </DashboardModule>
  )
}

export default AgencyDetails
